import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';

export const dismissRefresh = () => {
  return fetch(paths.api.dismissRefresh, {
    method: 'PATCH'
  });
};

export const fetchCheckpoints = () => {
  return fetch(paths.api.checkpointsV2);
};

export const fetchLiveClasses = (page: string) => {
  return fetch(paths.api.liveClassSessions({ page })).then((response) => {
    return response;
  });
};

export const fetchNotes = (section: string) => {
  return fetch(paths.api.notes(section)).then((response) => {
    return response.notes;
  });
};

export const fetchSegment = (id: number) => {
  return fetch(paths.api.segment(id)).then((response) => {
    return response.segment;
  });
};

export const fetchSidebar = () => {
  return fetch(paths.api.sidebarV2);
};

export const fetchStudyPlan = () => {
  return fetch(paths.api.studyPlanV2).then((response) => {
    return response.studyPlan;
  });
};

export const fetchStudyPlanChunks = ({ startingAt, numberOfChunks }) => {
  return fetch(paths.api.studyPlanItemsAsChunks(startingAt, numberOfChunks)).then((response) => {
    return response.chunks;
  });
};

export const fetchPresetStudyPlanItems = () => {
  return fetch(paths.api.presetStudyPlanItemsV2).then((response) => {
    return response.studyPlanItems;
  });
};

export const fetchCompletedStudyPlanItems = () => {
  return fetch(paths.api.completedStudyPlanItems).then((response) => {
    return response.studyPlanItems;
  });
};

export const fetchSubsections = (section: string) => {
  return fetch(paths.api.subsections(section)).then((response) => {
    return response.subsections;
  });
};


export const hideStudyPlanItem = ({ item, permanent }) => {
  return fetch(paths.api.hideStudyPlanItem(item.id || item.uuid, permanent), {
    method: 'PATCH'
  });
};

export const markStudyPlanItemComplete = (item) => {
  return fetch(paths.api.markStudyPlanItemCompleteV2(item.id || item.uuid), {
    method: 'PATCH'
  });
};

export const refreshPlan = (settings) => {
  return fetch(paths.api.createAdaptivePrepStudyPlan, {
    method: 'POST',
    body: JSON.stringify({ settings })
  });
};

export const updateStudyPlan = (params) => {
  return fetch(paths.api.studyPlanV2, {
    method: 'PATCH',
    body: JSON.stringify({ studyPlan: { ...params } })
  });
};

export const createOrFindStudyPlan = (params) => {
  return fetch(paths.api.studyPlanV2, {
    method: 'POST',
    body: JSON.stringify({ studyPlan: {...params} })
  })
};
